import types from './types';
import paySimpleService, {
  IPagination,
  IPaymentFilters
} from 'src/services/paySimple/paySimpleService';

import { IPaySimpleError } from './reducers';
import EcheckPaymentModel from 'src/model/echeckPayment.model';
import { sortBy } from 'lodash';

const getPayments = (
  filters: IPaymentFilters,
  pagination: IPagination,
  sort?: any
) => (dispatch: any) => {
  dispatch(setIsPending(true));
  dispatch(setError());

  paySimpleService
    .getPayments(filters, pagination, sort)
    .then(res => {
      dispatch(setData(res.data));
      dispatch(setPageNumber(res.pageNumber));
      dispatch(setPageSize(res.pageSize));
      dispatch(setTotalElements(res.totalElements));
      dispatch(setTotalPages(res.totalPages));
      dispatch(setIsPending(false));
    })
    .catch(error => {
      dispatch(setIsPending(false));
      dispatch(
        setError({
          hasFailed: true,
          message: error.message
        })
      );
    });
};

const updatePayment = (databaseId: number, params: any) => (
  dispatch: any,
  getState: any
) => {
  dispatch(setIsPending(true));
  dispatch(setError());

  paySimpleService
    .updatePayment(databaseId, params)
    .then(res => {
      const data = getState().payments.data;
      const dataUpdated = res;

      const index = data.findIndex((current: EcheckPaymentModel) => {
        return dataUpdated.paymentNumber === current.paymentNumber;
      });

      data[index] = dataUpdated;

      dispatch(setData(data));
      dispatch(setIsPending(false));
    })
    .catch(error => {
      dispatch(setIsPending(false));
      dispatch(
        setError({
          hasFailed: true,
          message: error.message
        })
      );
    });
};

const setData = (data: any[]) => {
  return { type: types.SET_PAYMENT_DATA, payload: data };
};

const setPageNumber = (pageNumber: number) => {
  return { type: types.SET_PAYMENT_PAGE_NUMBER, payload: pageNumber };
};

const setPageSize = (pageSize: number) => {
  return { type: types.SET_PAYMENT_PAGE_SIZE, payload: pageSize };
};

const setTotalElements = (totalElements: number) => {
  return { type: types.SET_PAYMENT_TOTAL_ELEMENTS, payload: totalElements };
};

const setTotalPages = (totalPages: number) => {
  return { type: types.SET_PAYMENT_TOTAL_PAGES, payload: totalPages };
};

const setIsPending = (isPending: boolean) => {
  return { type: types.SET_PAYMENT_IS_PENDING, payload: isPending };
};

const setError = (error?: IPaySimpleError) => {
  return {
    type: types.SET_PAYMENT_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

export default {
  getPayments,
  updatePayment
};
